import { Search } from "@mui/icons-material";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { css, StyleSheet } from "aphrodite";
import { formatContaContabil } from "../../helpers/formaters";

export const FilterPlanoContas = (props) => {
  const textFieldStyles = {
    marginTop: "0.5rem",
    "& .MuiInputBase-root": {
      height: "30px",
      fontSize: 12,
      backgroundColor: "inherit",
      display: "flex",
      alignItems: "center",
    },
    "& .MuiInputBase-input": {
      height: "30px",
      boxSizing: "border-box",
      cursor: "text",
      fontSize: "12px",
      textAlign: "left",
      '&[type="date"]': {
        fontSize: "14px",
      },
      "&.Mui-readOnly": {
        fontSize: "12px",
        "-webkit-text-fill-color": "inherit",
      },
      "&::placeholder": {
        fontSize: "12px",
        opacity: 1,
        textAlign: "left",
      },
    },
    "& .MuiInputLabel-root": {
      fontSize: 10,
      transform: "translate(10px, 6px) scale(1)",
      "& .MuiFormLabel-asterisk": {
        color: "red",
        fontWeight: "bold",
      },
    },
    "& .MuiInputLabel-shrink": {
      transform: "translate(10px, -8px) scale(0.75)",
    },
  };

  return (
    <Box>
      {props.isSearch ? (
        <Paper sx={{ borderRadius: 1, overflow: "hidden" }} elevation={1}>
          <Box
            sx={{
              px: 2,
              py: 0.5,
              bgcolor: "#669966",
              color: "white",
              fontWeight: 600,
              fontSize: 14,
            }}
          >
            Consulta de Plano Contas
          </Box>

          <Box sx={{ px: 1, paddingTop: 0.5, paddingBottom: 1.5 }}>
            <Grid container spacing={0.75} alignItems="flex-end">
              <Grid size={{ xs: 12, sm: 2.5, md: 2, xl: 1.75 }}>
                <TextField
                  sx={textFieldStyles}
                  label="Conta Contábil"
                  size="small"
                  fullWidth
                  color="success"
                  value={props.contaContabil}
                  onChange={(e) =>
                    props.setContaContabil(formatContaContabil(e.target.value))
                  }
                  onKeyDown={(e) => {
                    if (e.key === "Enter") props.searchPlanoContas();
                  }}
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 7.5, md: 8.5, xl: 8.25 }}>
                <TextField
                  sx={textFieldStyles}
                  label="Buscar Plano Contas"
                  size="small"
                  fullWidth
                  color="success"
                  value={props.searchValue}
                  onChange={(e) => props.setSearchValue(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") props.searchPlanoContas();
                  }}
                />
              </Grid>

              <Grid
                size={{ xs: 12, sm: 2, md: 1.5, xl: 2 }}
                sx={{
                  display: "flex",
                  justifyContent: { xs: "flex-start", sm: "flex-end" },
                }}
              >
                <IconButton
                  onClick={() => props.searchPlanoContas()}
                  className={css(styles.btn)}
                  title="Buscar"
                >
                  <Search fontSize="small" />
                </IconButton>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      ) : (
        <>
          <Paper sx={{ borderRadius: 1, overflow: "hidden" }} elevation={1}>
            <Box
              sx={{
                px: 2,
                py: 0.5,
                bgcolor: "#669966",
                color: "white",
                fontWeight: 600,
                fontSize: 14,
              }}
            >
              Informações Principais
            </Box>

            <Box sx={{ px: 1, pt: 0.5, pb: 1.5 }}>
              <Grid container spacing={0.75} alignItems="flex-end">
                <Grid size={{ xs: 12, sm: 3, xl: 2 }}>
                  <TextField
                    sx={textFieldStyles}
                    label="Conta Contábil"
                    required
                    size="small"
                    fullWidth
                    color="success"
                    error={props.errors.contaContabil}
                    inputRef={props.contaContabilRef}
                    value={props.contaContabil}
                    onChange={(e) => {
                      props.setContaContabil(
                        formatContaContabil(e.target.value),
                      );
                      if (props.errors?.contaContabil) {
                        props.setErrors((prev) => ({
                          ...prev,
                          contaContabil: false,
                        }));
                      }
                    }}
                  />
                </Grid>

                <Grid size={{ xs: 12, sm: 9, xl: 10 }}>
                  <TextField
                    sx={textFieldStyles}
                    label="Descrição"
                    size="small"
                    required
                    fullWidth
                    color="success"
                    error={props.errors.descricao}
                    inputRef={props.descricaoRef}
                    value={props.descricao}
                    onChange={(e) => {
                      props.setDescricao(e.target.value);
                      if (props.errors?.descricao) {
                        props.setErrors((prev) => ({
                          ...prev,
                          descricao: false,
                        }));
                      }
                    }}
                  />
                </Grid>

                <Grid size={{ xs: 12 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <fieldset
                      ref={props.tipoMovimentoRef}
                      tabIndex={-1}
                      style={{
                        margin: 0,
                        padding: "0 10px",
                        border: props.errors?.tipoMovimento
                          ? "1px solid #d32f2f"
                          : "1px solid #c4c4c4",
                        borderRadius: "4px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <legend
                        style={{
                          fontSize: "10px",
                          color: props.errors?.tipoMovimento
                            ? "#d32f2f"
                            : "#666",
                          padding: "0 4px",
                        }}
                      >
                        Tipo <span style={{ color: "red" }}>*</span>
                      </legend>
                      <RadioGroup
                        row
                        value={props.tipoMovimento}
                        onChange={(e) => {
                          props.setTipoMovimento(e.target.value);
                          if (props.errors?.tipoMovimento) {
                            props.setErrors((prev) => ({
                              ...prev,
                              tipoMovimento: false,
                            }));
                          }
                        }}
                      >
                        <FormControlLabel
                          value="Receita"
                          control={<Radio size="small" color="success" />}
                          label={
                            <span style={{ fontSize: "13px" }}>Receita</span>
                          }
                        />
                        <FormControlLabel
                          value="Despesa"
                          control={<Radio size="small" color="success" />}
                          label={
                            <span style={{ fontSize: "13px" }}>Despesa</span>
                          }
                        />
                      </RadioGroup>
                    </fieldset>

                    <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          color="success"
                          checked={props.analitica}
                          onChange={(e) => props.setAnalitica(e.target.checked)}
                        />
                      }
                      label={
                        <span style={{ fontSize: "13px" }}>Analítica</span>
                      }
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Paper>

          <Grid
            size={{ xs: 12 }}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: 0.5,
              mt: 1,
            }}
          >
            <Button
              variant="outlined"
              color="inherit"
              sx={{ minWidth: 120, fontSize: 12 }}
              onClick={() => props.handleBack()}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={() => props.cadPlanoContas()}
              sx={{ minWidth: 120, fontSize: 12, bgcolor: "#669966" }}
            >
              Salvar
            </Button>
          </Grid>
        </>
      )}
    </Box>
  );
};

const styles = StyleSheet.create({
  input: {
    fontFamily: "Poppins !important",
    fontSize: 12,
    fontWeight: 400,
    color: "#808080",
    transitionDuration: "0.2s",
  },
  btn: {
    backgroundColor: "#669966",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#669966",
    borderRadius: 6,
    display: "flex !important",
    justifyContent: "center !important",
    alignContent: "center !important",
    padding: 0,
    width: "100%",
    height: 30,
    transitionDuration: "0.2s",
    ":hover": {
      color: "#669966",
      backgroundColor: "transparent !important",
      borderColor: "#669966 !important",
    },
    ":active": {
      color: "#669966",
      backgroundColor: "transparent !important",
      borderColor: "#669966 !important",
      opacity: 0.6,
    },
  },
  btnDisabled: {
    backgroundColor: "#B3B3B3",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#B3B3B3",
    borderRadius: 6,

    display: "flex !important",
    justifyContent: "center !important",
    alignContent: "center !important",
    padding: 0,
    width: "100%",
    height: 34,
  },
  erro: {
    // fontFamily: "Poppins",
    fontSize: 14,
    color: "red",
    textAlign: "center",
    fontWeight: 600,
    marginTop: "1rem",
    marginBottom: "-0.5rem",
  },
});
